/**
 * @generated SignedSource<<9772ca359c2a81d83d1e5fd1f0204ca4>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type BuildsIndicator_pipeline$fragmentType: FragmentType;
export type BuildsIndicator_pipeline$data = {|
  +id: string,
  +runningBuilds: ?{|
    +count: number,
  |},
  +scheduledBuilds: ?{|
    +count: number,
  |},
  +uuid: string,
  +$fragmentType: BuildsIndicator_pipeline$fragmentType,
|};
export type BuildsIndicator_pipeline$key = {
  +$data?: BuildsIndicator_pipeline$data,
  +$fragmentSpreads: BuildsIndicator_pipeline$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildsIndicator_pipeline",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": "scheduledBuilds",
      "args": [
        {
          "kind": "Literal",
          "name": "state",
          "value": "SCHEDULED"
        }
      ],
      "concreteType": "BuildConnection",
      "kind": "LinkedField",
      "name": "builds",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "builds(state:\"SCHEDULED\")"
    },
    {
      "alias": "runningBuilds",
      "args": [
        {
          "kind": "Literal",
          "name": "state",
          "value": [
            "RUNNING",
            "FAILING"
          ]
        }
      ],
      "concreteType": "BuildConnection",
      "kind": "LinkedField",
      "name": "builds",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "builds(state:[\"RUNNING\",\"FAILING\"])"
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "dd4daba76fd0e9f9bb77feecab62d31b";

module.exports = ((node/*: any*/)/*: Fragment<
  BuildsIndicator_pipeline$fragmentType,
  BuildsIndicator_pipeline$data,
>*/);
